export default __webpack_public_path__ + "static/media/Q3_0_resized.55e5b676.jpg";